<form class="form-container" [formGroup]="risForm" (ngSubmit)="onSubmit()">
  @if (currentPage === 1) {
    <ng-container>
      <mat-form-field>
        <mat-label>{{ 'Projectname' | translate }}</mat-label>
        <input matInput id="name" type="text" formControlName="name" />
        <mat-error>
          {{ errorMessage }}
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'ProjectType' | translate }}</mat-label>
        <mat-select id="projectType" formControlName="projectType">
          @for (
            projectType of risProjectTypes;
            track projectType.projectTypeCode
          ) {
            <mat-option [value]="projectType.dynamicsCode">
              {{ projectType.projectTypeCode }}:
              {{ projectType.projectTypeName | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Project Manager' | translate }}</mat-label>
        <input
          type="text"
          matInput
          [placeholder]="'Search for a project manager' | translate"
          formControlName="projectManager"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onProjectManagerSelected($event)"
        >
          @for (person of filteredPeople | async; track person.id) {
            <mat-option [value]="person">
              {{ person.displayName }} ({{ person.userPrincipalName }})
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Project leading Department' | translate }}</mat-label>
        <mat-select id="leadingDepartment" formControlName="leadingDepartment">
          @for (department of departments; track department.id) {
            <mat-option [value]="department.name">{{
              department.name | translate
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </ng-container>
  }
  @if (currentPage === 2) {
    <ng-container>
      <mat-form-field>
        <mat-label>{{ 'Project Start Date' | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="startPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        @if (risForm.get('startDate')?.hasError('required')) {
          <mat-error>{{ 'Start date is required' | translate }}</mat-error>
        }
        @if (risForm.get('startDate')?.hasError('pastDate')) {
          <mat-error
            >{{ 'Start date must be in the future' | translate }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Project End Date' | translate }}</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="endPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        @if (risForm.get('endDate')?.hasError('required')) {
          <mat-error>{{ 'End date is required' | translate }} </mat-error>
        }
        @if (risForm.get('endDate')?.hasError('endDateBeforeStart')) {
          <mat-error
            >{{ 'End date must be after start date' | translate }}
          </mat-error>
        }
      </mat-form-field>

      @if (risForm.hasError('dateRange')) {
        <mat-error>{{
          'End date must be after start date' | translate
        }}</mat-error>
      }

      <div class="custom-form-field">
        <mat-label>{{
          'Has a Non-Disclosure Agreement' | translate
        }}</mat-label>
        <mat-button-toggle-group
          formControlName="hasNonDisclosure"
          aria-label="Has a Non-Disclosure Agreement"
          [hideSingleSelectionIndicator]="false"
        >
          <mat-button-toggle value="Yes">{{
            'Yes' | translate
          }}</mat-button-toggle>
          <mat-button-toggle value="No">{{
            'No' | translate
          }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <mat-form-field>
        <mat-label>{{ 'Strategic Topic' | translate }}</mat-label>
        <mat-select id="strategicTopic" formControlName="strategicTopic">
          @for (topic of strategicTopics; track topic.apiKey) {
            <mat-option [value]="topic.apiKey">{{
              topic.en | translate
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </ng-container>
  }
  <hr />
  <div class="form-footer">
    <div class="form-nav">
      <button
        mat-icon-button
        id="previous"
        [disabled]="isFirstPage()"
        (click)="previousPage()"
      >
        <i
          ><img
            src="../../../assets/icons/Arrow-Left-1--Streamline-Ultimate.svg"
        /></i>
      </button>
      <span class="text">Page {{ currentPage }} / {{ totalPages }}</span>
      <button
        mat-icon-button
        id="next"
        [disabled]="isLastPage()"
        (click)="nextPage()"
      >
        <i
          ><img
            src="../../../assets/icons/Arrow-Right-1--Streamline-Ultimate.svg"
        /></i>
      </button>
    </div>
    @if (isLastPage()) {
      <div class="submit">
        <button mat-flat-button color="primary" [disabled]="!risForm.valid">
          {{ 'Send' | translate }}
        </button>
      </div>
    }
  </div>
</form>
